import { render, staticRenderFns } from "./itDeclaration.vue?vue&type=template&id=6371fee7&scoped=true"
import script from "./itDeclaration.vue?vue&type=script&lang=js"
export * from "./itDeclaration.vue?vue&type=script&lang=js"
import style0 from "./itDeclaration.vue?vue&type=style&index=0&id=6371fee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371fee7",
  null
  
)

export default component.exports